
import { Component, Vue } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import purchaseRecord from "./components/purchase-record.vue";
import sendRecord from "./components/send-record.vue";
import i18n from "@/config/i18n";
@Component({
  components: {
    "pi-purchase-record": purchaseRecord,
    "pi-send-record": sendRecord
  }
})
export default class MessageRecord extends Vue {
  private tabsList: object[] = [
    { name: "tab1", title: i18n.t("messageRecord.tab1") },
    { name: "tab2", title: i18n.t("messageRecord.tab2") }
  ];
  private tabsActive = "tab1";
  public tabChange(data: string): void {
    this.tabsActive = data;
  }

  activated() {
    const operName = this.$route.query.operName;
    if (operName) {
      const purchaseRecord: objAny = this.$refs.purchaseRecord;
      purchaseRecord.routerQuery(operName);
    }
    const query = this.$route.query;
    if (query.auditStatus) {
      this.tabsActive = "tab1";
    }
  }
}
